import React from 'react';
import PropTypes from 'prop-types';
import { colourCanvas, colourMasterLighter } from 'Styles/colors.css';
import { circleProgressIndicator } from 'Shared/assets/images/';

export const LoadingSpinner = ({ isDevice, revealFormat }) => {
  const size = 30;
  const backgroundColor = isDevice ? colourCanvas : colourMasterLighter;
  return (<div
    id="loading-spinner"
    style={{
      width: '100%',
      height: '100%',
      position: 'absolute',
      ...(isDevice && revealFormat && { top: '0' }),
      ...(revealFormat && { top: '0', width: '100%', height: '100%' }),
      overflow: 'hidden',
      backgroundColor,
    }}
  >
    <div
      style={{
        display: 'block',
        position: 'absolute',
        left: `calc(50% - ${size / 2}px)`,
        top: `calc(50% - ${size / 2}px)`,
        width: `${size}px`,
        height: `${size}px`,
        background: `url(${circleProgressIndicator})`,
        backgroundSize: 'cover',
      }}
    />
  </div>
  );
};

LoadingSpinner.propTypes = {
  isDevice: PropTypes.bool,
  revealFormat: PropTypes.bool,
};

LoadingSpinner.defaultProps = {
  isDevice: false,
  revealFormat: false,
};


export default LoadingSpinner;



// WEBPACK FOOTER //
// ./app/javascript/packs/App/Preview/components/ResizableContainer/LoadingSpinner.jsx